import { useSearchParams } from 'react-router-dom'
import { useOpenCustomPageEditor } from 'app/hooks/useOpenCustomPageEditor'
import type { CustomPages } from 'app/types/entities'
import type { NavListEntry } from 'app/types/navigation'

/** Opens a sidebar saved list's editor. A save reloads the page when that list is the one on screen. */
export function useOpenNavListEditor(): (
  entry: NavListEntry,
  callbacks: { onSaved: () => void; onDeleted: () => void },
) => void {
  const [searchParams] = useSearchParams()
  const openCustomPageEditor = useOpenCustomPageEditor()

  return (entry, { onSaved, onDeleted }) =>
    openCustomPageEditor({
      customPage: entry.customPage!,
      list: entry.list,
      // A customPage entry only ever comes from a record type with a customPageType.
      pageType: entry.recordType as CustomPages,
      onSaved: () => {
        onSaved()
        // The sidebar refetch alone won't refresh the table already on screen for the list being edited.
        if (searchParams.get(`tab`) === entry.customPage!.id) window.location.reload()
      },
      onDeleted,
    })
}
